import DatabaseModel from './DatabaseModelOffline.js';

var Cliente = Object.create(DatabaseModel);

Cliente.model = 'clientes';

export default Cliente;